declare namespace $ {

	type $mol_link_iconed__uri_hack_app_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_iconed['uri'] >
	>
	type $mol_link_iconed__title_hack_app_2 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_link_iconed['title'] >
	>
	type $mol_link_source__uri_hack_app_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_source['uri'] >
	>
	type $mol_text__text_hack_app_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_page__title_hack_app_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_hack_app_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__title_hack_app_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__title_hack_app_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__title_hack_app_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__title_hack_app_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_book2_catalog__menu_title_hack_app_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_book2_catalog['menu_title'] >
	>
	type $mol_book2_catalog__param_hack_app_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_book2_catalog['param'] >
	>
	type $mol_book2_catalog__spreads_hack_app_13 = $mol_type_enforce<
		({ 
			'what_is': ReturnType< $hack_app['What_is'] >,
			'dict': ReturnType< $hack_app['Dict'] >,
			'roles': ReturnType< $hack_app['Roles'] >,
			'myths': ReturnType< $hack_app['Myths'] >,
		}) 
		,
		ReturnType< $mol_book2_catalog['spreads'] >
	>
	type $mol_page__title_hack_app_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__title_hack_app_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__title_hack_app_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_book2_catalog__menu_title_hack_app_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_book2_catalog['menu_title'] >
	>
	type $mol_book2_catalog__param_hack_app_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_book2_catalog['param'] >
	>
	type $mol_book2_catalog__spreads_hack_app_19 = $mol_type_enforce<
		({ 
			'pres': ReturnType< $hack_app['Presentation'] >,
			'design': ReturnType< $hack_app['Design'] >,
			'diagram': ReturnType< $hack_app['Diagram'] >,
		}) 
		,
		ReturnType< $mol_book2_catalog['spreads'] >
	>
	type $mol_page__title_hack_app_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__title_hack_app_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__title_hack_app_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__title_hack_app_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_book2_catalog__menu_title_hack_app_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_book2_catalog['menu_title'] >
	>
	type $mol_book2_catalog__param_hack_app_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_book2_catalog['param'] >
	>
	type $mol_book2_catalog__spreads_hack_app_26 = $mol_type_enforce<
		({ 
			'front': ReturnType< $hack_app['Front'] >,
			'back': ReturnType< $hack_app['Back'] >,
			'bd': ReturnType< $hack_app['Bd'] >,
			'hosting': ReturnType< $hack_app['Hosting'] >,
		}) 
		,
		ReturnType< $mol_book2_catalog['spreads'] >
	>
	type $mol_link__title_hack_app_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_hack_app_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_hack_app_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_hack_app_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_page__title_hack_app_31 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_hack_app_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $hack_app extends $mol_book2_catalog {
		Telegram( ): $mol_link_iconed
		GitHub( ): $mol_link_source
		About_text( ): $mol_text
		About_page( ): $mol_page
		What_is( ): $mol_page
		Dict( ): $mol_page
		Roles( ): $mol_page
		Myths( ): $mol_page
		First_page( ): $mol_book2_catalog
		Presentation( ): $mol_page
		Design( ): $mol_page
		Diagram( ): $mol_page
		Pres_design( ): $mol_book2_catalog
		Front( ): $mol_page
		Back( ): $mol_page
		Bd( ): $mol_page
		Hosting( ): $mol_page
		Start_page( ): $mol_book2_catalog
		Dosha( ): $mol_link
		VTB24( ): $mol_link
		Examples_page( ): $mol_page
		menu_title( ): string
		param( ): string
		menu_tools( ): readonly(any)[]
		menu_foot( ): readonly(any)[]
		spreads( ): ({ 
			'about': ReturnType< $hack_app['About_page'] >,
			'first': ReturnType< $hack_app['First_page'] >,
			'pres_design': ReturnType< $hack_app['Pres_design'] >,
			'start': ReturnType< $hack_app['Start_page'] >,
			'examples': ReturnType< $hack_app['Examples_page'] >,
		}) 
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map